<template>
  <article class="author">
    <div class="col-12 content no-gutters">
      <div class="row">
        <img class="col-12 no-gutters" :src="author.image" :alt="author.name + ' ' + author.surname">
      </div>
      <div class="row text">
        <div class="col-12">
          <h3>{{ author.name }} {{ author.surname }}</h3>
          <h4 class="title">{{ translation.title }}</h4>
        </div>
      </div>

    </div>
  </article>
</template>

<script>
  export default {
    name: 'AuthorCard',
    props: {
      author: {
        type: Object,
        required: true
      }
    },
    computed: {
      translation: function () {
        return this.author.authorTranslations[0]
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '~styles/_vars.scss';

  .author {
    margin-bottom: 2rem;
  }

  .content {
    transition: all 0.2s;
    background: $white;
    border-radius: $border-radius-standard;
    overflow: hidden;

    &:hover {
      box-shadow: 0 5px 15px rgba(0, 0, 0, 0.15);
    }
  }

  img {
    padding: 0;
    height: 20rem;
    background: $light-gray;
  }

  .text {
    padding: 1rem;
    color: $txt-color-primary;
    display: block;

    h3 {
      font-weight: $normal;
      font-size: 1.2rem;
      margin-bottom: 0.75rem;
    }

    h4 {
      color: $txt-color-secondary;
      font-size: 0.85rem;
    }
  }

</style>



// WEBPACK FOOTER //
// AuthorCard.vue?5a3d3390